import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { UiModule } from 'src/app/ui/ui.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { IDraftPlaceholder } from '../../../../models/compose.models';

export interface PlaceholdersConfirmDialogData {
  placeholders: IDraftPlaceholder[];
}

@Component({
  selector: 'app-placeholders-confirm-dialog',
  standalone: true,
  imports: [CommonModule, TranslateModule, UiModule, SharedModule],
  templateUrl: './placeholders-confirm-dialog.component.html',
  styleUrls: ['./placeholders-confirm-dialog.component.scss'],
})
export class PlaceholdersConfirmDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<PlaceholdersConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PlaceholdersConfirmDialogData,
  ) {}

  goBack(): void {
    this.dialogRef.close(false);
  }

  sendAnyway(): void {
    this.dialogRef.close(true);
  }
}
